<template>
   <div>
         <!-- <div class="bg-white  border border-dark" >
            <div class="d-flex justify-content-center " >
              <p class="" style="font-size: 13px;">West Nile Virus:</p>
              <p class="font-weight-bold" style="font-size: 13px;">4226</p>
            </div>
            <hr>
            <div class="d-flex justify-content-center">
              <p style="font-size: 13px;">Malaria:</p>
              <p class="font-weight-bold" style="font-size: 13px;">85246</p>
            </div>
            <hr>
            <div class="d-flex justify-content-center">
              <p style="font-size: 13px;">Dengue, Zika and Chikungunya:</p>
              <p class="font-weight-bold" style="font-size: 13px;">30249</p>
            </div>
            <hr>
            <div class="d-flex flex-row-reverse px-1">
              <p style="font-size: 11px;">Source: ECDC, EU/EEA Reported cases 2008-2020
              </p>
            </div>
          </div>-->
          <div>
            <img style="width:100%" src="../../public/img/image_2022_08_23T15_02_21_110Z.png" />
          </div>
          <div style="overflow:scroll; max-height: 60vh;">
            <div class="py-1"></div>
            <div class="border border-dark">
              <vue-highcharts :options="options" ref="lineCharts" style="height: 25vh;"></vue-highcharts>
            </div>
            <div class="py-1"></div>
            <div class="border border-dark">
              <vue-highcharts :options="options2" ref="lineCharts" style="height:25vh;"></vue-highcharts>
            </div>
            <div class="py-1"></div>
            <div class="border border-dark">
              <vue-highcharts :options="options3" ref="lineCharts" style="height:25vh;"></vue-highcharts>
            </div>
          </div>

        </div> 
</template>

<script>
import VueHighcharts from 'vue2-highcharts'

export default {
    components: {
        VueHighcharts
    },
 data () {
    return {
      

      optionsWind:{
        chart: {
          type: 'column'

        },
        title: {
          text: ''
        },
        yAxis: {
          title: {text:'m/sec',},
          tickAmount: 10
        },
        credits: {
          enabled: false
        },
        series: [],
      },

      options: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'West Nile Virus reported cases (ECDC)',
          style: {
            fontSize: '13px'
          }
        },

        xAxis: {
          categories: [
            '2008',
            '2009',
            '2010',
            '2011',
            '2012',
            '2013',
            '2014',
            '2015',
            '2016',
            '2017',
            '2018',
            '2019',
            '2020',
            '2021',
            '2022',
            '2023',
            '2024',
          ],
          crosshair: true
        },
        yAxis: {
          tickAmount: 10,
          min: 0,
          title: {
            text: ''
          }
        },

        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          itemStyle: {
            fontSize: '10px'
          }
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'EU/EEA Reported cases',
          data:[24,30,	356,	150,	287,	331,	78,	128,	240,	208,	1615,	443,336,139,1340,709,1436]

        },/* {
          name: 'EU',
          data: [	24,	30,	356,	150,	287,	331,	78,	128,	240,	208,	1615,	443,316]

        },*/ {
          name: 'France',
          data:[0	,1	,3	,1	,3	,1	,0	,1	,3	,2	,29	,4,0,0,6,43,39]

        }, {
          name: 'Greece',
          data: [0,	0,	262,	100,	163,	86,	15,	0,	0,	48,	316,	227,143,57,286,162,218]

        }, {
          name: 'Italy',
          data:[3	,18	,11	,32	,73	,160	,24	,62	,81	,54	,618	,55,66,55,588,336,455]

        }, {
          name: 'Serbia',
          data:[0	,0	,0,	0	,69	,302	,76	,28	,41	,49	,415	,32,0,18,169,91,63]

        }, {
          name: 'Germany',
          data: [0	,0	,0	,0	,0	,0	,0	,0	,0	,0	,11	,12,13,4,8,6,27]

        }]
      },
      options2: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Malaria reported cases (ECDC)',
          style: {
            fontSize: '13px'
          }
        },
        xAxis: {
          categories: [
            '2008',
            '2009',
            '2010',
            '2011',
            '2012',
            '2013',
            '2014',
            '2015',
            '2016',
            '2017',
            '2018',
            '2019',
            '2020',
            '2021',
            '2022'
          ],
          crosshair: true
        },
        yAxis: {
          tickAmount: 10,
          min: 0,
          title: {
            text: ''
          }
        },

        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          itemStyle: {
            fontSize: '10px'
          }
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'EU/EEA Reported cases',
          data:[5181	,5386	,6018	,6258	,5897	,6614	,7831	,8407	,8226	,8427	,8363	,8638,2480,4862,6131]

        },/* {
          name: 'EU',
          data:[5149	,5352	,5981	,6228	,5860	,6542	,7711	,8313	,8149	,8363	,8306	,8438,0]

        },*/ {
          name: 'France',
          data:[2246	,2199	,2439	,1891	,1851	,2165	,2299	,2500	,2447	,2712	,2840	,2839,1007,2321,2783]


        }, {
          name: 'Greece',
          data: [	39	,51	,45	,92	,95	,25	,38	,84	,121	,107	,55	,40,23,32,30]

        }, {
          name: 'Italy',
          data:[	583	,636	,698	,701	,642	,677	,705	,706	,888	,830	,722	,811,181,443,571]

        }, {
          name: 'Serbia',
          data:[0	,0	,0,	0	,0	,0	,0,0	,0	,0,0,0,0,0,0]

        }, {
          name: 'Germany',
          data: [	0	,0	,0	,563	,551,	638	,1007	,1061	,962	,957	,899	,993,366,613,768	]

        }]
      },
      options3: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Dengue, Zika and Chikungunya reported cases (ECDC)',
          style: {
            fontSize: '13px'
          }
        },
        xAxis: {
          categories: [
            '2008',
            '2009',
            '2010',
            '2011',
            '2012',
            '2013',
            '2014',
            '2015',
            '2016',
            '2017',
            '2018',
            '2019',
            '2020',
            '2021',
            '2022'
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },

        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          itemStyle: {
            fontSize: '10px'
          }
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'EU/EEA Reported cases',
          data:[571	,726,	1801,	665	,1307,	2772,	3650,	2996,	5506,	2848,	2435,	4950,2161,462,1855]

        },/* {
          name: 'EU',
          data: [	571	,726	,1801,	665,	1277,	2715,	3577,	2869,	3323,	2538,	2334,	4773,22]


        }, */{
          name: 'France',
          data:[57	,77	,640	,67	,163	,468	,1155	,353	,1556	,329	,357	,1028,1378,234,401]

        }, {
          name: 'Greece',
          data: [0	,0	,0	,0	,0	,1	,5	,2	,6	,2	,5	,12,1,1,5]

        }, {
          name: 'Italy',
          data:[21	,13	,58	,46	,79	,145	,118	,121	,224	,409	,114	,260,55,11,136]

        }, {
          name: 'Serbia',
          data:[0	,0	,0,	0	,69	,302	,76	,28	,41	,49	,415	,32,0,0,0]

        }, {
          name: 'Germany',
          data: [290	,352	,632	,301	,625	,893	,788	,832	,1032	,736	,658	,1274,232,66,401]

        }]
      },
    };
  },

}

</script>


<style scoped>

</style>